import type React from 'react'
import { SLIDER_IMAGES } from '@/constants'
import { useLanguage } from '@/landing/contexts/LanguageContext'

export const HeroSection: React.FC = () => {
  const { t } = useLanguage()

  return (
    <div className="w-full h-[260px] overflow-hidden bg-black relative mb-8 flex items-center">
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      <div className="flex animate-slide-left h-[200px]" style={{ width: '300%' }}>
        {[...SLIDER_IMAGES, ...SLIDER_IMAGES, ...SLIDER_IMAGES].map((image, index) => (
          <div key={`slide-${index}`} className="flex-shrink-0 h-full flex items-center">
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="h-full w-auto object-cover opacity-80 hover:opacity-100 transition-opacity"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center text-white z-20">
          <h1
            className="text-5xl font-black mb-4 text-white uppercase tracking-wide"
            style={{
              textShadow:
                '3px 3px 6px rgba(0,0,0,0.9), 0px 0px 20px rgba(0,0,0,0.7), 2px 2px 0px rgba(0,0,0,1)',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            {t('main_page.hero.title')}
          </h1>
          <p
            className="text-2xl font-light text-white tracking-wide"
            style={{
              textShadow:
                '2px 2px 4px rgba(0,0,0,0.9), 0px 0px 15px rgba(0,0,0,0.7), 1px 1px 0px rgba(0,0,0,1)',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            {t('main_page.hero.subtitle')}
          </p>
        </div>
      </div>
    </div>
  )
}
